import { Injectable, OnDestroy } from "@angular/core";
import { environment } from "src/environments/environment";
import { EAthenaMessageTypes } from "./enum/message-extension.enum";
import { BehaviorSubject, Subject } from "rxjs";
import { EACTIVE_TAB } from "../tabs-mapper/tabs-mapper.model";

@Injectable({
  providedIn: "root"
})


/**
 * This service is responsible for sending messages to the Athena Extension.
 */

export class ExtensionMessagePublisherService implements OnDestroy {

  constructor() { }


  private _destroy$ = new Subject<void>();

  private _queries = new BehaviorSubject<number>(null);

  private _isCdiReportSent = false;

  private _previousTab: EACTIVE_TAB;

  _sendMessage<T>(type: string, value?: T) {
    const message = {
      type, value, version: 2
    };

    console.log("Sending message to Athena Extension:", message);
    window.parent.postMessage(message, environment.athenaEhrUrl);
  }

  sendLoginSuccessMessage() {
    this._sendMessage(EAthenaMessageTypes.LOGIN_SUCCESS);
  }

  sendCdiReportLoadingComplete() {
    this._sendMessage(EAthenaMessageTypes.CDI_REPORT_LOADING_COMPLETE);
  }

  republishCdiReportLoadingComplete() {
    if (!this._isCdiReportSent) {
      return;
    }
    this._sendMessage(EAthenaMessageTypes.CDI_REPORT_LOADING_COMPLETE);
  }

  sendRiskGapCount(riskGap: number) {
    this._sendMessage(EAthenaMessageTypes.RISK_GAP_COUNT, riskGap);
  }

  sendQueriesCount(queries: number) {
    this._queries.next(queries);
    this._sendMessage(EAthenaMessageTypes.QUERIES_COUNT, queries);
  }

  navigateToPatientPage(patientId: string) {
    this._sendMessage(EAthenaMessageTypes.NAVIGATE_TO_PATIENT, patientId);
  }

  republishQueriesCount() {
    if (this._queries.getValue()) {
      this._sendMessage(EAthenaMessageTypes.QUERIES_COUNT, this._queries.getValue());
    }
  }

  /**
   * This method is used to initiate the scraping process
   * for the Athena DOM, which is typically used to extract
   * relevant data from the Athena interface.
   *
   * The scrapeAthenaDom method triggers scraping of the Athena DOM
   * and sends a message to the evaire application.
   *
   */
  scrapeAthenaDom() {
    this._sendMessage(EAthenaMessageTypes.SCRAPE_ATHENA_DOM);
  }

  clearPullTabCount(activeTab?: EACTIVE_TAB) {

    if (!activeTab) {
      this._sendMessage(EAthenaMessageTypes.CLEAR_PULLTAB_COUNT);
    }

    switch (activeTab) {
      case EACTIVE_TAB.PATIENT:
        if (this._previousTab === EACTIVE_TAB.NON_PATIENT) {
          this._sendMessage(EAthenaMessageTypes.CLEAR_PULLTAB_COUNT);
        }
        this._previousTab = EACTIVE_TAB.PATIENT;
        break;

      case EACTIVE_TAB.NON_PATIENT:
        this._sendMessage(EAthenaMessageTypes.CLEAR_PULLTAB_COUNT);
        this._previousTab = EACTIVE_TAB.NON_PATIENT;
        break;
    }

  }

  providerRiskGapsSaved() {
    this._sendMessage(EAthenaMessageTypes.PROVIDER_RISK_GAPS_SAVED);
  }

  publishLogoutSuccess() {
    this._sendMessage(EAthenaMessageTypes.LOGOUT_SUCCESS);
  }

  publishAppComponentInitialized(){
    this._sendMessage(EAthenaMessageTypes.APP_COMPONENT_INITIALIZED);
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

}
